export const categorys = ['IT', '자기계발', '여행', '경제', '취미', '외국어', '맛집', '기타'];